import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { Close } from '@element-plus/icons-vue';
import { loanPledge } from '@/config/sensors';
import { saPushEvent } from '@/utils/sensors';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    content: {
      type: String,
      default: '',
      required: true
    },
    confirmText: {
      type: String,
      default: '',
      required: true
    },
    type: {
      type: String,
      default: '',
      required: false
    }
  },
  emits: ['update:visible'],
  components: {
    Close
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    const sensorsMap = {
      kyc: {
        event: loanPledge.kyc_dialog,
        click: loanPledge.kyc_dialog_btn,
        btnEvent: loanPledge.kyc_dialog_btn,
        area: 'PostBorrowingPopUp',
        confirm: 'KYCCertify'
      },
      account: {
        event: loanPledge.account_dialog,
        click: loanPledge.account_dialog_btn,
        btnEvent: loanPledge.account_dialog_btn,
        area: 'PostKYCPopUp',
        confirm: 'ClientServiceOnline'
      }
    };
    const changeVisible = btn => {
      const {
        type
      } = props;
      saPushEvent(sensorsMap[type].click, {
        page_name: loanPledge.home,
        plate_area: sensorsMap[type].area,
        button_name: btn
      });
      emit('update:visible', false);
    };
    const handleConfirm = () => {
      emit('update:visible', false);
      const {
        type
      } = props;
      saPushEvent(sensorsMap[type].click, {
        page_name: loanPledge.home,
        plate_area: sensorsMap[type].area,
        button_name: sensorsMap[type].confirm
      });
      if (type === 'kyc') {
        // 完成基础认证
        const idAuthLink = '/user/accounts/auth/personal';
        window.open(idAuthLink);
        return;
      }
      if (type === 'account') {
        // 联系客服
        if (window.adaEmbed) window.adaEmbed.toggle();
      }
    };
    watch(() => props.visible, visible => {
      if (visible) {
        saPushEvent(sensorsMap[props.type].event, {
          page_name: loanPledge.home,
          plate_area: sensorsMap[props.type].area
        });
      }
    });
    return {
      t,
      changeVisible,
      handleConfirm
    };
  }
};